
<header>
  <section class="left">
    <icon-button
      class="menu"
      icon="menu"
      @click="$store.commit('SET_NAV_OPEN', !navOpen)"
    />
  </section>

  <section :class="['middle', { open: searchOpen }]">
    <global-search ref="cardSearch" />

    <icon-button
      class="close-search-icon"
      icon="close"
      @click="searchOpen = false"
    />
  </section>

  <section class="right">
    <icon-button
      class="nav-icon search-icon"
      icon="search"
      @click="openSearch"
    />

    <icon-button
      class="nav-icon"
      icon="help_outline"
      as="a"
      href="https://cardladder.zendesk.com/hc/en-us"
      rel="noopener noreferrer"
      target="_blank"
      tooltip="Help"
    />

    <icon-button
      class="nav-icon"
      icon="add_circle"
      tooltip="Submit Sale"
      @click="submitSale"
    />

    <icon-button
      v-if="isStaff"
      class="nav-icon"
      icon="assignment"
      as="router-link"
      tooltip="Reports"
      to="/reports"
    />

    <icon-button
      class="nav-icon medium-up"
      icon="price_check"
      tooltip="Price check"
      @click="showPriceCheckModal = true"
    />

    <icon-button
      class="nav-icon"
      icon="notifications_none"
      tooltip="Notifications"
      :alert="hasUnreadNotifications"
      @click="openNotificationsPanel"
    />

    <dropdown
      v-if="user"
      align="right"
      :active="menuOpen"
      @close="menuOpen = false"
    >
      <avatar
        :image-url="user.photoUrl"
        @click.native="menuOpen = !menuOpen"
      />

      <template #menu>
        <dropdown-menu
          :options="accountOptions"
          :max-height="500"
          @select="handleSelect"
        />
      </template>
    </dropdown>
  </section>

  <portal to="feedback">
    <feedback-modal
      title="Submit Request"
      subtitle="Tell us about the issue you're facing or give feedback"
      :open="showFeedbackModal"
      @close="showFeedbackModal = false"
    />

    <price-check-modal
      :open="showPriceCheckModal"
      @close="showPriceCheckModal = false"
    />
  </portal>
</header>
